module.exports = __webpack_public_path__ + "static/img/avatar-05.894004e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/profiles/avatar-05.jpg
// module id = TIAn
// module chunks = 22